"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInIntegerRange = exports.integerRangeJsonSchema = void 0;
exports.integerRangeJsonSchema = {
    type: "object",
    required: [],
    properties: {
        min: { type: "number" },
        max: { type: "number" },
    },
};
function isInIntegerRange(num, range) {
    const { min, max } = range;
    if (typeof min === "number" && num < min) {
        return false;
    }
    if (typeof max === "number" && num > max) {
        return false;
    }
    return true;
}
exports.isInIntegerRange = isInIntegerRange;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSW50ZWdlclJhbmdlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2ludGVyZmFjZXMvSW50ZWdlclJhbmdlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUthLFFBQUEsc0JBQXNCLEdBQUc7SUFDcEMsSUFBSSxFQUFFLFFBQVE7SUFDZCxRQUFRLEVBQUUsRUFBRTtJQUNaLFVBQVUsRUFBRTtRQUNWLEdBQUcsRUFBRSxFQUFFLElBQUksRUFBRSxRQUFRLEVBQUU7UUFDdkIsR0FBRyxFQUFFLEVBQUUsSUFBSSxFQUFFLFFBQVEsRUFBRTtLQUN4QjtDQUNGLENBQUM7QUFFRixTQUFnQixnQkFBZ0IsQ0FBQyxHQUFXLEVBQUUsS0FBbUI7SUFDL0QsTUFBTSxFQUFFLEdBQUcsRUFBRSxHQUFHLEVBQUUsR0FBRyxLQUFLLENBQUM7SUFFM0IsSUFBSSxPQUFPLEdBQUcsS0FBSyxRQUFRLElBQUksR0FBRyxHQUFHLEdBQUcsRUFBRTtRQUN4QyxPQUFPLEtBQUssQ0FBQztLQUNkO0lBRUQsSUFBSSxPQUFPLEdBQUcsS0FBSyxRQUFRLElBQUksR0FBRyxHQUFHLEdBQUcsRUFBRTtRQUN4QyxPQUFPLEtBQUssQ0FBQztLQUNkO0lBRUQsT0FBTyxJQUFJLENBQUM7QUFDZCxDQUFDO0FBWkQsNENBWUMifQ==